export type CreateSPBOrderResponse = {
  /** paypal order id */
  orderToken: string;
};

export type CapturePaypalOrderResponse = {
  /** capture失败的error code信息 */
  authCode: 'INSTRUMENT_DECLINED' | 'INTERNAL_SERVICE_ERROR' | string;
};

/**
 * forter风控内部区分的auth type（比如云存升级 / 主动续费等场景不同auth结果不同）
 * 和后端的/subscribeForterAdaptiveAuth接口中 adaptiveAuthType的类型一致
 */
export enum ForterAdaptiveAuthType {
  /**
   * 订阅更新默认auth type
   */
  DEFAULT = 'default',
  /**
   * 主动续费场景
   */
  PAYMENT_AND_UPDATE = 'paymentAndUpdate',
}

/** 内部命名的支付处理场景key，可以映射到后端的其他处理值。 */
export enum OrderToPayAdaptiveEnum {
  /** 订阅续费 主动支付场景 */
  'updatePay' = ForterAdaptiveAuthType.PAYMENT_AND_UPDATE,
}

/** order.topay接口的参数，用于给支付方式使用 */
export type TOrderToPayPayload = {
  /**
   * 当前支付是什么类型场景（比如云存主动支付 / 或者其他的场景）
   */
  adaptiveType: keyof typeof OrderToPayAdaptiveEnum;
};
